import { CorporateClubMermberExtract } from '@smiles/voebiz-core-corporate-club/dist/Types/GetCorporateClubMemberExtractApi.types';
import { formatMiles } from 'helpers/format';
import { formatDate } from 'helpers/formatDate';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface RowProps {
  extract: CorporateClubMermberExtract;
}

function Row({ extract }: RowProps) {
  const { t } = useTranslation();

  return (
    <div className="corporate-club-extract__card__body__table__row">
      <div className="corporate-club-extract__card__body__table__row__data">
        <h4 className="corporate-club-extract__card__body__table__row__data__title">{t('common:plan')}</h4>
        <p className="corporate-club-extract__card__body__table__row__data__value">
          Clube {formatMiles(extract.accumulatedMiles)}
        </p>
      </div>
      <div className="corporate-club-extract__card__body__table__row__data">
        <h4 className="corporate-club-extract__card__body__table__row__data__title">{t('common:date')}</h4>
        <p className="corporate-club-extract__card__body__table__row__data__value">
          {formatDate(extract.recorrenceDate)}
        </p>
      </div>
      <div className="corporate-club-extract__card__body__table__row__data">
        <h4 className="corporate-club-extract__card__body__table__row__data__title">
          {t('glossary:milesAccumulated')}
        </h4>
        <p className="corporate-club-extract__card__body__table__row__data__value">
          {formatMiles(extract.accumulatedMiles)} {t('common:miles')}
        </p>
      </div>
    </div>
  );
}

export default Row;
